import { useState, useEffect } from "react";
import Map from "../../Map";
import VerticalCarousel from "./VerticalCarousel";
import UnclaimedOrEmpty from "./UnclaimedOrEmpty";

const FirmDetails = (props) => {
  const { awards, accreditations, location, name, unclaimed, firmId, claimProfileUrl, render = true } = props;
  const [locationData, setLocationData] = useState(null);
  const [awardsList, setAwardsList] = useState(null);

  useEffect(() => {
    if (location && location?.postcode) {
      const address = `${
        location.address_line1 ? location.address_line1 + "," : ""
      } ${location.address_line2 ? location.address_line2 + "," : ""} ${
        location.town ? location.town + "," : ""
      } ${location.postcode}`;
      setLocationData({
        address,
        postcode: location.postcode,
      });
    }

    let awardsAndAccreditations = [];
    if (awards && awards.length) {
      awardsAndAccreditations = [...awardsAndAccreditations, ...awards];
    }
    if (accreditations && accreditations.length) {
      awardsAndAccreditations = [...awardsAndAccreditations, ...accreditations];
    }

    if (awardsAndAccreditations.length) {
      setAwardsList(awardsAndAccreditations);
    }
  }, []);

  if (!render) return null

  return (
      <div className='flex gap-4 mt-4 mb-12 [&_.vfIcon]:border-solid [&_.vfIcon]:border-[1px] [&_.vfIcon]:m-2 [&_svg]:!text-[1.3rem] max-sm:flex-wrap bg-very-pale-mint-green p-8 py-6 max-xs:py-4 max-xs:!my-0'>
        <div className='flex-auto max-w-[50%] [&_.google-map]:mt-4 [&_.google-map]:max-h-52 [&_.google-map]:w-full [&_.google-map>div>div]:rounded-2xl max-sm:w-full max-sm:max-w-full' data-test="location-section">
          {locationData ? (
            <>
              <Map
                hideCircle
                address={`${locationData.postcode}, UK`}
                radiusMile={50}
                infoWindowContent={`
                          <div>
                              ${locationData.address}
                          </div>
                      `}
              />
              <div className='flex pt-4 location-address'>
                <p className='text-sm m-0'>
                  {locationData.address}
                </p>
              </div>{" "}
            </>
          ) : (
            <UnclaimedOrEmpty
              text={`${name} have not provided a location yet.`}
              subtext={`Do you work at ${name}?`}
              linkText="Add location"
              unclaimed={unclaimed}
              firmId={firmId}
              claimProfileUrl={claimProfileUrl}
              utmTerm="location"
            />
          )}
        </div>

        <div className='flex-[2_1_auto] max-w-[50%] max-sm:max-w-full content-center text-center' data-test="awards-section">
          {!unclaimed && awardsList ? (
            <VerticalCarousel
              title="Awards and Accreditations"
              type="awards"
              icon={null}
              data={awardsList}
              firmOrNetworkType={props.firmOrNetworkType}
              fullWidth={!locationData}
              dataTestTitle="awards-and-accreditations-title"
            />
          ) : (
            <>
              <h5 className="flex text-center self-center items-center justify-center" data-test="awards-and-accreditations-unclaimed-or-empty-title">
                Awards and Accreditations
              </h5>

              <UnclaimedOrEmpty
                text={`${name} have not provided any awards or accreditations yet.`}
                subtext={`Do you work at ${name}?`}
                linkText="Add awards"
                unclaimed={unclaimed}
                firmId={firmId}
                claimProfileUrl={claimProfileUrl}
                utmTerm="awards"
              />
            </>
          )}
        </div>
      </div>
  );
};

export default FirmDetails;
